import { ComunicacaoService } from './../../../shared/services/comunicacao.service';
import { ValidacaoComponent } from './../../veiculo/orcamento/validacao/validacao.component';
import { OrcamentoService } from './../../../shared/services/orcamento.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SessionService } from './../../../shared/services/session.service';
import { MessageService } from './../../../shared/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StatusOrcamento } from '../status-orcamento.enum';
import { AtribuicaoComponent } from '../../atribuicao/atribuicao.component';
import { permissaoAtribuicao } from 'src/app/shared/models/permissoes';
import { ValidacaoConsultaComponent } from '../../consulta-pecas/validacao-consulta/validacao-consulta.component';
import { ModalOrcamentoInfoComponent, dadosChamadoModal } from '../modal-orcamento-info/modal-orcamento-info.component';
import { FotosComponent } from '../../veiculo/orcamento/fotos/fotos.component';
import { Veiculo } from '../../veiculo/shared/model/veiculo.model';
import { LaudopmmgComponent } from '../../veiculo/orcamento/laudopmmg/laudopmmg.component';
import { LaudopmmgPrintComponent } from '../../veiculo/orcamento/laudopmmg-print/laudopmmg-print.component';
declare var $: any;

@Component({
  selector: 'app-todos-orcamentos',
  templateUrl: './todos-orcamentos.component.html',
  styleUrls: ['./todos-orcamentos.component.css', './todos-orcamentos.component.scss']
})
export class TodosOrcamentosComponent implements OnInit {
  sub: any;
  bsModalRef: BsModalRef;
  update: boolean;
  itens: Array<any>;
  offset: number = 1;
  page: number = 1;
  limit: number = 10;
  totalRegistros: number;
  resourceFormSearch: FormGroup;
  placa_novo: string;
  data_novo: string;
  nome_novo: string;
  responsavel_novo: string;
  situacao_novo: string;
  protocolo_novo: string;
  status1: boolean = true;
  status2: boolean = false;
  status3: boolean = false;
  //status
  status: string = StatusOrcamento.TODOS;

  //resumo
  resumo: ResumoOrcamento = new ResumoOrcamento;
  listaStatus: Array<any> = [
    { "value": "aprovado", "label": "Aprovado" },
    { "value": "negado", "label": "Negado" },
    { "value": "aguardando", "label": "Aguardando" },
    { "value": "todos", "label": "Todos" },
    { "value": "finalizado", "label": "Finalizado" },
    { "value": "execucao", "label": "Execução" },
    { "value": "divergencia", "label": "Divergência" },
    { "value": "cotacao", "label": "Cotação" },
    { "value": "perda_total", "label": "Perda Total" },
    { "value": "ausente", "label": "Ausente" },
    { "value": "pendente", "label": "Pendente" },
    { "value": "analise", "label": "Análise" },
    { "value": "pendente_distribuicao", "label": "Pen. Distribuição" },
  ];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private session: SessionService,
    private formBuilder: FormBuilder,
    private info: MessageService,
    private rest: OrcamentoService,
    private modalService: BsModalService,
    private comu: ComunicacaoService
  ) {
    this.comu.listen().subscribe((m: any) => {
      if (m == 'closed-atribuicao') {
        this.loadItens();
        this.getResumo();
      }
    });
  }

  buildResourceForm() {

    //form search
    this.resourceFormSearch = this.formBuilder.group({
      placa: [null, []],
      nome: [null, []],
      cpf: [null, []],
      protocolo: [null, []],
      data_inicial: [null, []],
      data_final: [null, []],
      status: [null, []],

      tipoTicket: [null, []]
    });
  }

  tipoEmpresa() {
    return this.session.getTipoEmpresa();
  }

  arrowUp() {
    this.status1 = true
    this.status2 = false
  }
  arrowDown() {
    this.status1 = false
    this.status2 = true

  }

  abrirCadastro() {
    if (this.session.getTipoEmpresa() == 'OFICINA')
      this.router.navigate(['/orcamento/register']);
    else {
      this.rest.cadastroAtivo().subscribe((data: any) => {
        if (data.cadastro_ativo) this.router.navigate(['/orcamento/register']);
        else this.info.showAlert("Antes de cadastrar um orçamento você precisa cadastrar uma oficina!");
      });
    }
  }

  orcamentoNovo() {
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined) {
        this.protocolo_novo = params['id'];
      }
    })
  }

  allowRegister() {
    //console.log(this.session.getPlanId());
    return this.checkInGrupo([1, 2, 3, 4, 5, 6, 7, 8]) && this.session.getPlanId() != undefined && !this.session.isMaster();
  }

  onSearch(event) {
    //get input name
    let inputName = event.target.id;
    //clear
    if (inputName != "placa") {
      this.resourceFormSearch.get("placa")?.setValue("");
    }
    if (inputName != "nome") {
      this.resourceFormSearch.get("nome")?.setValue("");
    }
    if (inputName != "cpf") {
      this.resourceFormSearch.get("cpf")?.setValue("");
    }
    if (inputName != "protocolo") {
      this.resourceFormSearch.get("protocolo")?.setValue("");
    }
    //pres ENTER?
    if (event.keyCode === 13) {
      //let value = this.resourceFormSearch.get(inputName)?.value;
      //get dados
      this.loadItens(true);
    }
  }

  semPermissao() {
    this.info.showErro('Sem premissão');
  }

  onlyDate(date) {
    if (date == "" || date == null) {
      return null;
    }
    date = new Date(date);
    var month = date.getMonth() + 1;
    if (month < 10) month = "0" + month;
    var dateOfMonth = date.getDate();
    if (dateOfMonth < 10) dateOfMonth = "0" + dateOfMonth;
    var year = date.getFullYear();
    return year + "-" + month + "-" + dateOfMonth;
    //return date.toISOString().split('T')[0];
  }

  async updateStatus(url) {
    $('app-button-status-num').tooltip('hide')
    this.resourceFormSearch.reset();
    if (this.sub) this.sub.unsubscribe();
    await this.router.navigateByUrl(url);
    this.getFilterStatus();
    //this.loadItens();
  }

  loadItens(firstPage = false, bySelect: boolean = false) {
    if (firstPage) this.page = 1;


    //status formated backEnd
    let status
    if (!bySelect)
      status = StatusOrcamento[this.status];
    else {
      status = this.resourceFormSearch.get('status').value;
    }

    let type = "date";
    let placa = this.resourceFormSearch.get('placa')?.value;
    let cpf = this.resourceFormSearch.get('cpf')?.value;
    let nome = this.resourceFormSearch.get('nome')?.value;
    let protocolo = this.resourceFormSearch.get('protocolo')?.value;
    let data_inicial = this.onlyDate(this.resourceFormSearch.get('data_inicial')?.value);
    let data_final = this.onlyDate(this.resourceFormSearch.get('data_final')?.value);

    if (data_inicial == null) {
      data_inicial = "2022-01-01";//default
    }
    if (data_final == null) {
      let year = new Date().getFullYear();
      data_final = year + "-12-31";//default
    }

    if (placa && placa.length > 0) {
      type = "placa";
    } else if (cpf && cpf.length > 0) {
      type = "client";
    } else if (nome && nome.length > 0) {
      type = "clientNome";
    } else if (protocolo && protocolo.length > 0) {
      type = "protocol";
    }

    let postData = {
      "method": "GET",
      "type": type,
      "status": status,
      "placa": placa, //busca placa
      "taxId": cpf, //busca cpf
      "name": nome, //busca nome
      "protocol": protocolo, //busca protocol
      "limit": this.limit,
      "offset": this.page,
      "betweenDate": {
        "start": data_inicial,
        "end": data_final
      },
      "cargoId": this.session.getCargo(),
      "usuario": this.session.getEmail()
    }
    this.rest.getOrcamentos(postData).subscribe(
      data => {
        var response = JSON.parse(JSON.stringify(data));
        this.totalRegistros = response.totalRegistros;
        let dados = response.data;
        //console.log(this.itens);
        if (typeof dados === 'object' && typeof dados[0] === 'object') {
          this.itens = dados;
          /* setTimeout(() => {
            jQuery(function () {
              (jQuery('[data-toggle="tooltip"]') as any).tooltip();
            });
          }, 500); */
          //console.log(this.itens)
        } else {
          this.itens = [];
        }
      });
  }

  retornaUUIDEmpresaAtual() {
    return this.session.getUUIDEmpresa();
  }

  retornaStatus(uuidEmp, status, status2, status3) {
    if (uuidEmp == this.session.getUUIDEmpresa()) {
      return status;
    }
    else {
      if (this.session.getTipoEmpresa() == 'REGULADORA') {
        if (status2)
          return status2;
        else return 'PENDENTE';
      }
      else if (this.session.getTipoEmpresa() == 'OFICINA') {
        if (status3)
          return status3;
        else if (status2)
          return 'PENDENTE';
        else return 'PENDENTE';
      }
    }
    return null;
  }
  //+(item.status == 'NÃO AUTORIZADO')?'NEGADO':(item.status == 'AUTORIZADO')?'APROVADO':item.status
  empresaHeDona(uuidDona): boolean {
    return (uuidDona == this.session.getUUIDEmpresa());
  }

  getResumo() {
    this.rest.getResumo().subscribe(
      result => {
        let dados = result.data[0];
        this.resumo = new ResumoOrcamento;
        //console.log(dados.aprovados);
        //console.log( Number(dados.aprovados))
        this.resumo.aprovado = (dados.aprovados == null) ? 0 : Number(dados.aprovados);
        //this.resumo.orcamento =  (dados.orcamento == null)? 0 : Number(dados.orcamento);
        this.resumo.negado = (dados.negados == null) ? 0 : Number(dados.negados);
        this.resumo.divergencia = (dados.divergencia == null) ? 0 : Number(dados.divergencia);
        this.resumo.execucao = (dados.execucao == null) ? 0 : Number(dados.execucao);
        this.resumo.finalizado = (dados.finalizado == null) ? 0 : Number(dados.finalizado);
        this.resumo.perda_total = (dados.perda_total == null) ? 0 : Number(dados.perda_total);
        this.resumo.ausente = (dados.ausente == null) ? 0 : Number(dados.ausente);
        /* this.resumo.todos = (dados.total == null) ? 0 : Number(dados.total); */
        this.resumo.analise = (dados.analise == null) ? 0 : Number(dados.analise);
        this.resumo.aguardando = (dados.aguardando == null) ? 0 : Number(dados.aguardando);
        this.resumo.pendente_distribuicao = (dados.pendente_distribuicao == null) ? 0 : Number(dados.pendente_distribuicao);
        this.resumo.pendente = (dados.pendente == null) ? 0 : Number(dados.pendente);
        this.resumo.sumTotal();
        /* if (this.session.getTipoEmpresa() == 'CORPORATE') {
          this.resumo.pendente = (dados.analise == null) ? 0 : Number(dados.analise);
          this.resumo.aguardando = (dados.cotacao == null) ? 0 : Number(dados.cotacao);
        }
        else {
          this.resumo.pendente = (dados.pendente == null) ? 0 : Number(dados.pendente);
          this.resumo.aguardando = (dados.analise == null) ? 0 : Number(dados.analise);
        } */


        /* this.resumo.cotacao = (dados.cotacao == null) ? 0 : Number(dados.cotacao);
        this.resumo.aguardando = (dados.aguardando == null) ? 0 : Number(dados.aguardando); */

        //console.log("teste")
        //console.log(dados)
      });
  }

  pageChange(event) {
    this.page = event;
    this.loadItens();
  }

  abrirEdicao(protocolo) {
    //this.info.showAlert("Ao finalizar a edição do orçamento todos os itens adicionados a ele seram excluidos!")
    this.router.navigate(['/orcamento/register/', protocolo])
  }

  getFilterStatus() {

    if (this.sub) this.sub.unsubscribe();

    //status parameter 
    this.sub = this.route.params.subscribe(params => {
      //console.log('aqui')
      if (params['status'] !== undefined) {
        let status = params['status'];
        const keys = Object.keys(StatusOrcamento);
        if (keys.includes(status.toUpperCase()) == false) {
          alert('Status do orçamento desconhecido');
        } else {
          this.status = status.toUpperCase();
          //alert(this.status)
        }
      }
      this.loadItens(true);
    }
    );

  }

  ngOnInit(): void {
    $('.btn').tooltip('hide')
    // Ativar Tooltip
    $(function () { $('[data-toggle="tooltip"]').tooltip() });
    //console.log(this.itens)
    this.orcamentoNovo()
    //console.log('protoclo',this.protocolo_novo)
    this.buildResourceForm()
    this.getFilterStatus();
    //this.loadItens();
    this.getResumo();
    //this.orcamentoNovo()

    //this.abrirConsultaDePecas();

  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }


  openValidacao(protocolo: string, ofi: any) {
    if ((ofi == null || ofi == undefined || ofi == '') && (this.session.getTipoEmpresa() != 'OFICINA')) {
      this.info.showAlert('O orçamento não possui oficina cadastrada <br> Edite o orçamento e adicione uma oficina para acessar');
      return;
    }
    const initialState = {
      protocolo: protocolo
    };
    this.bsModalRef = this.modalService.show(ValidacaoComponent, { initialState, class: 'modal-dialog modal-xl modal-validacao' });

  }

  openAtribuicao(protocolo: string) {
    const initialState = {
      protocolo: protocolo
    };
    this.bsModalRef = this.modalService.show(AtribuicaoComponent, { initialState, class: 'modal-dialog modal-md' });

  }

  checkInGrupo(grupoIds = []) {
    return this.session.checkInGrupo(grupoIds);
  }

  abrirRelatorio(protocolo) {
    this.router.navigate(['/veiculo/relatorio/' + protocolo]);
  }

  copiar(texto) {
    navigator.clipboard.writeText(texto)
  }
  voltarOrcamentoEmpresaDona(protocolo, v, vv) {
    this.info.showConfirme('O veículo está ausente e o orçamento será devolvido para a empresa \n Você tem certeza disso?').then((r: any) => {
      if (r.isConfirmed) {
        let reguladora = false;
        this.itens.map(iten => { if (iten.protocolo == protocolo) reguladora = true; });
        this.rest.retornarOrcamentoParaEmpresa(protocolo, 'AUSENTE', reguladora ? 'AUSENTE' : null, 'AUSENTE').subscribe((data: any) => {
          if (data.status == 'success') {
            this.info.customAlert({
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
              },
              icon: 'success',
              html: 'Orçamento devolvido',
              backdrop: true,
              focusConfirm: true,
              timer: 1500,
              timerProgressBar: true
            });
            let versao;
            if (v == -1) {
              versao = 'V1.0';
            } else {
              let v1 = String(vv).split('.')[0];
              versao = v1 + '.' + v;
            }
            //let versao = "V1.0";//seta valor da versão vizual do orçamento
            this.rest.criarVersao(protocolo, versao).subscribe((dataV: any) => {//realiza a solicitação do versionamento
              if (dataV.status == 'success' || dataV.code == '404') {//valida se a criação da versão foi bem sucedida
                var response = JSON.parse(JSON.stringify(dataV));
              }
            });
            this.loadItens();
          }
          else this.info.showErro('Erro ao retornar Orçamento');
        });
      }
      else {
        this.info.customAlert({
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
          },
          icon: 'error',
          html: 'Ação Cancelada',
          backdrop: true,
          focusConfirm: true,
          timer: 1500,
          timerProgressBar: true
        });
      }
    });
  }

  botaoEntrarIF(status: string): boolean {
    let listaStatus: Array<any> = ['APROVADO', 'REPROVADO', 'NEGADO', 'FINALIZADO']
    if (listaStatus.indexOf(status) != -1) return false;
    return true;
  }

  botaoReabrirIF(status: string, dona): boolean {
    let listaStatus: Array<any> = ['APROVADO', 'REPROVADO', 'NEGADO', 'FINALIZADO']
    if (listaStatus.indexOf(status) != -1 && dona == this.session.getUUIDEmpresa()) return true;
    return false;
  }

  execReabrirOrcamento(protocolo, reguladora: boolean = false, complemento:string='N') {
      this.rest.retornarOrcamentoParaEmpresa(protocolo, 'PENDENTE', reguladora ? 'ANALISE' : null, 'ANALISE', complemento).subscribe((data: any) => {
      if (data.status = 'success') {
        this.loadItens();
      }      
    });
  }

  reabrirOrcamento(protocolo, reguladora: boolean = false, status:string) {
    let isComplemento = (status=='APROVADO' || status=='FINALIZADO');
    if(isComplemento){
      this.info.showConfirme("Tem certeza que deseja reabrir o orçamento?<br/>Novas peças adicionadas serão classificadas como complemento ao orçamento")
      .then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.execReabrirOrcamento(protocolo,reguladora,'S')
        } 
      });
    }else{
      this.execReabrirOrcamento(protocolo,reguladora,'N');
    }

  }

  podeAbrirAtribuicao(): boolean {
    if (permissaoAtribuicao.indexOf(this.session.getCargo()) != -1)
      return true;
    return false;
  }

  abrirConsultaDePecas() {
    this.bsModalRef = this.modalService.show(ValidacaoConsultaComponent, { class: 'modal-dialog modal-xl' });
  }

  abrirModalInfo(orcamento) {
    let dados: dadosChamadoModal = new dadosChamadoModal();
    dados.placa = orcamento?.placa;
    dados.responsavel = orcamento?.atr_nome;
    dados.atribuicao = orcamento?.atr_fantasia;
    dados.protocolo = orcamento?.protocolo;
    dados.cobertura = (orcamento.protocolo_orcamento_relacionado == '' || orcamento.protocolo_orcamento_relacionado ==
      null) ? 'Associado' : 'Terceiro';
    dados.data_abertura = orcamento?.data_abertura;
    dados.nome = orcamento?.solicitante;
    dados.situacao = this.retornaStatus(orcamento.uuid_emp_orcamento,
      orcamento.status, orcamento.status_atribuido, orcamento.status_atribuido_2);
    const initialState = {
      jsonDados: dados,
    };
    this.bsModalRef = this.modalService.show(ModalOrcamentoInfoComponent, { initialState })
  }

   openModalFotos(protocolo:string) {
     this.rest.getOrcamentoProtocol(protocolo).subscribe(
          data => {   
            console.log(data)       
            var response = JSON.parse(JSON.stringify(data));
            //console.log(response)
            let dados = response.data[0];
            let resource = new Veiculo();    
            resource.dados = dados;        
             const initialState = {
            'veiculo': resource,
            'readonly': true
          };
          this.bsModalRef = this.modalService.show(FotosComponent, { initialState, class: 'modal-dialog modal-xl' });
          });


        }
        
openModalLaudoPMMG(eProtocolo:string) {
    const initialState = {
      protocolo: eProtocolo,
    };
    this.bsModalRef = this.modalService.show(LaudopmmgComponent, { initialState, class: 'modal-dialog modal-xl',
        //backdrop: 'static',
        //keyboard: false 
        }) ;
    // Quando fechar o modal
    this.bsModalRef.content.onClose.subscribe(() => {
      
    });
  }

  openRelatorioLaudoPmg(eProtocolo:string) {
    const initialState = {
      protocolo: eProtocolo,
    };
    this.bsModalRef = this.modalService.show(LaudopmmgPrintComponent, { initialState, class: 'modal-dialog modal-xl',
        //backdrop: 'static',
        //keyboard: false 
        }) ;
    // Quando fechar o modal
    this.bsModalRef.content.onClose.subscribe(() => {
      
    });
  }



getPrimeiroEUltimo(nome: string | null | undefined): string {
  if (!nome) return "";

  const partes = nome.trim().split(/\s+/).filter(p => p.length > 0);

  // Sem nomes válidos
  if (partes.length === 0) return "";

  // Somente um nome → retorna ele mesmo
  if (partes.length === 1) return partes[0];

  const primeiro = partes[0];
  const ultimo = partes[partes.length - 1];

  return `${primeiro} ${ultimo}`;
}
        
}

export class ResumoOrcamento {
  //orcamento:number=0;
  aprovado: number = 0;
  negado: number = 0;
  aguardando: number = 0;
  todos: number = 0;
  finalizado: number = 0;
  execucao: number = 0;
  divergencia: number = 0;
  cotacao: number = 0;
  perda_total: number = 0;
  ausente: number = 0;
  pendente: number = 0;
  analise: number = 0;
  pendente_distribuicao: number = 0;

  sumTotal() {
    this.todos = Number(this.aprovado) + Number(this.negado) + Number(this.aguardando) + Number(this.todos) + Number(this.finalizado) + Number(this.execucao) + Number(this.divergencia) + Number(this.cotacao) + Number(this.perda_total) + Number(this.ausente) + Number(this.pendente) + Number(this.analise) + Number(this.pendente_distribuicao);
  }

}




